<template>
  <div class="loading">
    <transition name="loading-fade">
      <div
        v-show="loading"
        key="content"
        class="loading__content"
        :style="{ backgroundColor }"
      >
        <img class="loading__animation" :src="require('@/assets/heart.svg')" />
      </div>
    </transition>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'LoadingComponent',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: '#fff'
    }
  }
}
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  justify-content: center;
  height: 100%;

  &-fade-enter-active,
  &-fade-leave-active {
    transition: opacity 0.3s ease;
  }
  &-fade-enter-from,
  &-fade-leave-to {
    opacity: 0;
  }

  &__content {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    align-items: center;
    display: flex;
    justify-content: center;
    z-index: 10;
  }

  &__animation {
    animation: 0.75s infinite ease-in-out beatHeart;
    width: 20px;
    height: 16px;
  }
}
</style>
